import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ContributionSchema = withDefaults({
  type: 'contribution',
  fields: [
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'balance',
    },
    {
      kind: 'attribute',
      name: 'status',
    },
    {
      kind: 'attribute',
      name: 'type',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default ContributionSchema;
